export enum Language {
  FR = 'FR',
  EN = 'EN',
  ES = 'ES'
}
